import React from 'react';
import { LiaArrowCircleDownSolid } from "react-icons/lia";
import FadeIn from '../common/FadeIn';

const ProcessHero = () => {
  return (
    <div className="h-[65vh] md:h-[65vh] p-[70px_25px] bg-[#341e12] text-white text-center flex flex-col items-center justify-between">
      <FadeIn>
        <p className='leading-[1] tracking-[0em] text-[22px] md:text-[30px] font-normal'>
          <span className='font-PromenadeItalic'>By</span> <span className='font-saolDisplayItalic'> Princy Patel | SeaSalt Creative </span>
        </p>
      </FadeIn>

      <div className="my-auto flex flex-col items-center justify-center">
        <FadeIn>
          <h2 className='font-interDisplayMedium text-[14px] md:text-base leading-[1.2] tracking-[0.1em] font-normal uppercase text-center mb-[35px]'>
            Website Development
          </h2>
        </FadeIn>
        <FadeIn>
          <h1 className='font-saolDisplayItalic text-[28px] md:text-[66px] tracking-[0em] text-center uppercase leading-[1.1] font-normal max-w-[716px] mx-auto'>
            Websites made to feel like you.
          </h1>
        </FadeIn>
      </div>

      <FadeIn>
        <div className='flex gap-3 items-center font-PromenadeItalic leading-[1] tracking-[0em] text-[22px] md:text-[30px] text-center font-normal'>
          Scroll
          <LiaArrowCircleDownSolid />
          Down
        </div>
      </FadeIn>
    </div>
  );
};

export default ProcessHero;
